// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Zq5q","flexWrapper":"styles_flexWrapper__3GQHr","layoutWrapper":"styles_layoutWrapper__1klp7","backButton":"styles_backButton__12l9p"};